import { Box, Typography } from "@mui/material";
import { NwAutocomplete, NwTextField } from "@nawy/ui";
import { Controller, useFormContext } from "react-hook-form";
import { FinishingType, FinishingTypes } from "@/modules/property-tracks/types";
import type { EditListingFormValues } from "./schema";

const finishingOptions = (
  Object.keys(FinishingTypes) as FinishingType[]
).map((key) => ({
  value: key,
  label: FinishingTypes[key],
}));

export const UnitDetailsFields = () => {
  const { control } = useFormContext<EditListingFormValues>();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          color: "text.secondary",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}
      >
        Unit Details
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { mobile: "1fr", tablet: "1fr 1fr" },
          gap: "12px",
        }}
      >
        <Controller
          name="numberOfBedrooms"
          control={control}
          render={({ field, fieldState }) => (
            <NwTextField
              {...field}
              label="Bedrooms"
              type="number"
              size="small"
              fullWidth
              inputProps={{ min: 0 }}
              value={field.value ?? ""}
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="numberOfBathrooms"
          control={control}
          render={({ field, fieldState }) => (
            <NwTextField
              {...field}
              label="Bathrooms"
              type="number"
              size="small"
              fullWidth
              inputProps={{ min: 0 }}
              value={field.value ?? ""}
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="unitArea"
          control={control}
          render={({ field, fieldState }) => (
            <NwTextField
              {...field}
              label="Unit area (m²)"
              type="number"
              size="small"
              fullWidth
              inputProps={{ min: 0 }}
              value={field.value ?? ""}
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="floorNumber"
          control={control}
          render={({ field, fieldState }) => (
            <NwTextField
              {...field}
              label="Floor number"
              type="number"
              size="small"
              fullWidth
              value={field.value ?? ""}
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </Box>

      <Controller
        name="finishing"
        control={control}
        render={({ field, fieldState }) => {
          const current =
            finishingOptions.find((opt) => opt.value === field.value) ?? null;
          return (
            <NwAutocomplete
              options={finishingOptions}
              value={current}
              onChange={(option) =>
                field.onChange(option?.value ?? undefined)
              }
              label="Finishing"
              placeholder="Select finishing"
              error={Boolean(fieldState.error)}
              helperText={fieldState.error?.message}
            />
          );
        }}
      />
    </Box>
  );
};

export default UnitDetailsFields;
